import { forwardRef, useEffect, useState } from "react";
import FlashingDotSVG from "./FlashingDotSVG";
import { Tooltip } from "antd";

const FlashingDot = forwardRef((props, ref) => {
  const { onClick, param = null, position, tooltip = null } = props;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {tooltip ? (
        <Tooltip
          placement={tooltip.placement}
          title={tooltip.title}
          color={tooltip.color}
        >
          <button
            ref={ref}
            style={{
              position: "absolute",
              left: position.x,
              top: position.y,
              width: 25,
              height: 25,
              background: "none",
              border: "none",
              transitionProperty: "opacity",
              opacity: visible ? 1 : 0,
              transition: "opacity 3s ease-in",
            }}
            onClick={param ? () => onClick(param) : () => onClick()}
          >
            <FlashingDotSVG position={{ x: -12, y: -12 }} />
          </button>
        </Tooltip>
      ) : (
        <button
          ref={ref}
          style={{
            position: "absolute",
            left: position.x,
            top: position.y,
            width: 25,
            height: 25,
            background: "none",
            border: "none",
            transitionProperty: "opacity",
            opacity: visible ? 1 : 0,
            transition: "opacity 3s ease-in",
          }}
          onClick={param ? () => onClick(param) : () => onClick()}
        >
          <FlashingDotSVG position={{ x: -12, y: -12 }} />
        </button>
      )}
    </>
  );
});

export default FlashingDot;